import {
  collectionGroup,
  doc,
  setDoc,
  query,
  where,
  collection,
} from "firebase/firestore";
import { firestore } from "services/firebaseService/firebaseConfig";
import { ACTIVITY_STATUS_EVENTS_REF, ACTIVITY_STATUS_REF } from "./constants";
import { IEventActivityStatus } from "./types";

export const getActivityStatusEventsRef = (eventId: string) =>
  query(
    collectionGroup(firestore, ACTIVITY_STATUS_EVENTS_REF),
    where("eventId", "==", eventId),
  );

export const setActivityStatus = (
  eventId: string,
  userId: string,
  { label, status }: IEventActivityStatus,
) => {
  const ref = doc(
    collection(
      doc(firestore, ACTIVITY_STATUS_REF, userId),
      ACTIVITY_STATUS_EVENTS_REF,
    ),
    eventId,
  );

  return setDoc(ref, { label, status, eventId, userId });
};
